/** Hands bytes to the browser as a file download under the given name. */
export function downloadBlob(data: BlobPart, filename: string, type: string): void {
  const url = window.URL.createObjectURL(new Blob([data], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
